import { render } from "./pop-up-confirm-phone.vue?vue&type=template&id=869297de&scoped=true"
import script from "./pop-up-confirm-phone.vue?vue&type=script&lang=js"
export * from "./pop-up-confirm-phone.vue?vue&type=script&lang=js"

import "./pop-up-confirm-phone.vue?vue&type=style&index=0&id=869297de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869297de"]])

export default __exports__